import { Controller } from "stimulus"

export default class extends Controller {
    static targets = ["add1Image","add2Image","addButton","renew"]
    connect(){
        const img1 = this.add1ImageTarget.querySelector('img')
        const img2 = this.add2ImageTarget.querySelector('img')
        if(img2.getAttribute('src') !== ''){
            this.add1ImageTarget.classList.remove('is-hidden')
            this.add2ImageTarget.classList.remove('is-hidden')
        }else if(img1.getAttribute('src') !== ''){
            this.add1ImageTarget.classList.remove('is-hidden')
        }

        if(!this.add1ImageTarget.classList.contains('is-hidden') && !this.add2ImageTarget.classList.contains('is-hidden')){
            this.addButtonTarget.classList.add('is-hidden')
        }
    }

    addUploadField(e){
        const add1Image = this.add1ImageTarget
        const add2Image = this.add2ImageTarget
        if(add1Image.classList.contains('is-hidden')){
            add1Image.classList.remove('is-hidden')
        }else if(add2Image.classList.contains('is-hidden')){
            add2Image.classList.remove('is-hidden')
            this.addButtonTarget.classList.add('is-hidden')
        }
    }

    renewToTrue(){
        this.renewTarget.value = true
    }
}